// Constants
import ACTIONS from "@/Constants/actionsList";

const PAYROLL_MAPPING_TABS = [
	{ key: "pay-items", label: "Pay Items" },
	{ key: "custom-field-items", label: "Custom Field Items" },
];

const PAYROLL_MAPPING_KEYS = {
	QUERY: {
		PAY_ITEMS_OPTIONS: "getPayItemOptionsByLocationId",
		SYSTEM_PAY_ITEMS: "systemPayItems",
		PAY_ITEMS_SELECTION: "payItemsSelection",
		CUSTOM_FIELD_DEFINITIONS: "getCustomFieldDefinitionsByLocationId",
		MAPPED_CUSTOM_FIELDS: "mappedCustomFields",
		MAPPED_PAY_ITEMS: "mappedPayItems",
	},
	MUTATION: {
		UPDATE_MAPPED_PAY_ITEMS: "updateMappedPayItems",
		UPDATE_MAPPED_CUSTOM_FIELDS: "updateMappedCustomFields",
		UPDATE_PAY_ITEMS_OPTIONS: "updatePayItemsOptions",
	},
	SUBSCRIPTION: {
		PAY_ITEMS: "payItemsMap",
		MAPPED_CUSTOM_FIELDS: "onUpdateMappedCustomFields",
		CUSTOM_FIELD_DEFINITIONS: "onUpdateCustomFieldDefinitions",
		MAPPED_PAY_ITEMS: "onUpdateMappedPayItems",
		PAY_ITEMS_OPTIONS: "onUpdatePayItemsOptions",
	},
};

const REQUIRED_ACTIONS = [ACTIONS.VIEW_PAY_ITEMS_MAPPING, ACTIONS.VIEW_CUSTOM_FIELD_ITEMS_MAPPING];

const UNIQUE_PAY_ITEMS = [
	{ systemPayItem: "Commission Draw" },
	{ systemPayItem: "Advanced Commissions" },
	{ systemPayItem: "Hourly Draw" },
	{ systemPayItem: "Flat Draw" },
] as const;

const UNIQUE_PAY_ITEMS_SET = new Set<string>(UNIQUE_PAY_ITEMS.map((item) => item.systemPayItem));

const SKELETON_ROWS_COUNT = 12;
const MINUTES_FOR_OPTIONS_STALE_TIME = 5;
const STALE_TIME_OPTIONS = MINUTES_FOR_OPTIONS_STALE_TIME * 60 * 1000; // 5 minutes
const STALE_TIME_SELECTION = 60 * 1000; // 1 minute

const MAXIMUM_CUSTOM_FIELD_ITEMS_PER_MAPPING = 2;
const MAXIMUM_PAY_ITEMS_PER_MAPPING = 2;

export {
	PAYROLL_MAPPING_TABS,
	PAYROLL_MAPPING_KEYS,
	REQUIRED_ACTIONS,
	UNIQUE_PAY_ITEMS,
	UNIQUE_PAY_ITEMS_SET,
	SKELETON_ROWS_COUNT,
	STALE_TIME_OPTIONS,
	STALE_TIME_SELECTION,
	MAXIMUM_CUSTOM_FIELD_ITEMS_PER_MAPPING,
	MAXIMUM_PAY_ITEMS_PER_MAPPING,
};
